<template>
  <div class="form_box">
    <el-form ref="form" :model="form" label-width="80px">
      <!-- 昵称 -->
      <div class="tx_box">
        <div>姓名：</div>
        <div>{{ userInfo.trueName }}</div>
      </div>
      <!-- 性别： -->
      <div class="tx_box">
        <div>性别：</div>
        <!-- <radio-group v-model="form.gender"> -->
        <div class="radio_box">
          <input
            disabled
            class="radio"
            type="radio"
            id="one"
            value="男"
            v-model="this.picked"
          />
          <label for="one">男</label>
        </div>
        <div class="radio_box">
          <input
            disabled
            class="radio"
            type="radio"
            id="two"
            value="女"
            v-model="this.picked"
          />
          <label for="one">女</label>
        </div>
        <!-- </radio-group> -->
        <!-- <el-radio-group v-model="form.gender">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group> -->
      </div>
      <!-- 账号 -->
      <div class="tx_box">
        <div>账号：</div>
        <div>{{ userInfo.username }}</div>
      </div>
      <!-- 身份证号 -->
<!--      <div class="tx_box">-->
<!--        <div>身份证号：</div>-->
<!--        <div>{{ userInfo.idNum }}</div>-->
<!--      </div>-->
      <!-- 民族 -->
<!--      <div class="tx_box">-->
<!--        <div>民族：</div>-->
<!--        <select disabled class="minxu" @change="getMinzu" name="" id="">-->
<!--          <option>-->
<!--            {{ userInfo.nation }}-->
<!--          </option>-->
<!--        </select>-->
<!--      </div>-->
      <!-- 籍贯 -->
<!--      <div class="tx_box">-->
<!--        <div>籍贯：</div>-->
<!--        <v-distpicker-->
<!--          disabled-->
<!--          :province="address.province"-->
<!--          :city="address.city"-->
<!--          :area="address.county"-->
<!--          @selected="onSelected"-->
<!--        ></v-distpicker>-->
<!--      </div>-->
      <!-- 家庭地址 -->
      <div class="tx_box">
        <div>家庭住址：</div>
        <input
          type="text"
          placeholder="请输入详细家庭住址"
          v-model="userInfo.address"
          @input="changeAddress($event, 0)"
        />
      </div>
      <!-- 邮箱： -->
      <div class="tx_box">
        <div>邮箱：</div>
        <input
          type="text"
          placeholder="请输入您的常用邮箱"
          v-model="userInfo.email"
          @input="changeAddress($event, 1)"
        />
      </div>
      <!-- <el-form-item> -->
      <div @click="onSubmit" class="btn">保存</div>
      <!-- </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import Bus from "../../../bus.js";
import store from "store";
import VDistpicker from "v-distpicker";
import { goChangeInfo, getMyUserInfo } from "../../../assets/js/api.js";
export default {
  components: {
    VDistpicker,
  },
  data() {
    return {
      userInfo: "",
      minzuSelected: "汉族",
      picked: "",
      form: {
        realName: "",
        gender: 0,
        email: "",
        sign: "",
      },
      options: ["汉族", "a", "b"],
      address: {
        province: "",
        city: "",
        county: "",
      },
      homeAddress: "",
      email: "",
    };
  },

 // created(){
 //   this.getUserInfo()
 // },
  mounted() {
    this.getUserInfo();
  },

  methods: {
    // 获取信息
    getUserInfo() {
        getMyUserInfo(localStorage.getItem("siteId"),localStorage.getItem("info")).then((res) => {
        if (res.code == 200) {
            console.log(res)
          this.userInfo = res.data;
          Bus.$emit("userInfo", this.userInfo);
          // store.set("userInfo2", this.userInfo);
          // this.address.province = this.userInfo.native_place.split("-")[0];
          // this.address.city = this.userInfo.native_place.split("-")[1];
          // this.address.county = this.userInfo.native_place.split("-")[2];
          if (parseInt(this.userInfo.sex) == 0) {
            this.picked = "男";
          } else {
            this.picked = "女";

          }
          console.log(this.picked)
        }
      });
    },
    // 修改信息
    onSubmit() {
      if (!this.homeAddress && !this.email) {
        this.$message.error("请输入修改内容！");
        return;
      }
      if (!this.homeAddress) {
        this.homeAddress = this.userInfo.home_address;
      }
      if (!this.email) {
        this.email = this.userInfo.email;
      }
      goChangeInfo(this.homeAddress, this.email, this.userInfo.id).then(
        (res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("修改成功！");
            this.homeAddress = "";
            this.email = "";
            this.getUserInfo();
            return;
          } else {
            this.$message.error(res.msg);
            return;
          }
        }
      );
    },
    changeAddress(e, i) {
      // console.log(e.target.value);
      if (i == 0) {
        this.homeAddress = e.target.value;
      } else {
        this.email = e.target.value;
      }
    },
    // 监听省市区
    onSelected(data) {
      this.address.province = data.province.value;
      this.address.city = data.city.value;
      this.address.county = data.area.value;
    },
    // 监听民族选项
    getMinzu(e) {
      // console.log(e);
      // console.log(this.minzuSelected);
    },
  },
};
</script>
<style lang="less" scoped>
.form_box {
  width: 700px;
  margin-top: 40px;
  font-size: 14px;
  color: #333;
  margin-left: 30px;
  .tx_box {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    font-size: 16px;
    color: #343434;
    margin-top: 40px;
    div:nth-child(1) {
      width: 90px;
      text-align: right;
      margin-right: 20px;
    }
    input {
      width: 340px;
      height: 40px;
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 4px;
      padding-left: 10px;
      box-sizing: border-box;
    }
    .radio_box {
      margin-right: 40px;
      display: flex;
      align-items: center;
      .radio {
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
    }
    .minxu {
      width: 157px;
      height: 40px;
      border: 1px solid #cccccc;
      border-radius: 4px;
      padding-left: 10px;
      box-sizing: border-box;
    }
    @deep: ~">>>";
    .el-date-editor.el-input,
    .el-input--prefix .el-input__inner {
      width: 230px;
      height: 30px;
      //   padding-left: 10px;
    }
    @deep: ~">>>";
    .el-input__inner {
      padding-left: 10px;
      border: 1px solid #ccc;
    }
    // @deep: ~">>>";
    // .el-radio__label {
    //   font-size: 16px;
    //   color: #343434;
    // }
  }
  .btn {
    width: 144px;
    height: 40px;
    background: #029aff;
    border-radius: 4px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    margin-left: 110px;
  }
}
</style>
